// App.js v1.5
import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import Login from './screens/Login';
import Layout from './components/Layout';
import Dashboard from './screens/Dashboard';
import VehicleEntry from './screens/VehicleEntry';
import VehicleExit from './screens/VehicleExit';
import Tenants from './screens/Tenants';
import MOU from './screens/MOU';
import Accounting from './screens/Accounting';
import Reports from './screens/Reports';
import Settings from './screens/Settings';
import ShiftClose from './screens/ShiftClose';
import CarHistory from './screens/CarHistory';
import './App.css';

const Protected = ({ children, adminOnly=false, adminOrSupervisor=false }) => {
  const { user, loading } = useAuth();
  if (loading) return <div className="loading-screen"><div className="spinner"/></div>;
  if (!user) return <Navigate to="/login" replace/>;
  if (adminOnly && user.role !== 'admin') return <Navigate to="/dashboard" replace/>;
  if (adminOrSupervisor && user.role === 'staff') return <Navigate to="/dashboard" replace/>;
  return children;
};

const AppRoutes = () => {
  const { user } = useAuth();
  return (
    <Routes>
      <Route path="/login" element={user ? <Navigate to="/dashboard" replace/> : <Login/>}/>
      <Route path="/" element={<Protected><Layout/></Protected>}>
        <Route index element={<Navigate to="/dashboard" replace/>}/>
        <Route path="dashboard" element={<Dashboard/>}/>
        <Route path="entry" element={<VehicleEntry/>}/>
        <Route path="exit" element={<VehicleExit/>}/>
        <Route path="tenants" element={<Protected adminOrSupervisor><Tenants/></Protected>}/>
        <Route path="mou" element={<Protected adminOrSupervisor><MOU/></Protected>}/>
        <Route path="accounting" element={<Protected adminOnly><Accounting/></Protected>}/>
        <Route path="reports" element={<Reports/>}/>
        <Route path="settings" element={<Protected adminOnly><Settings/></Protected>}/>
        <Route path="shift-close" element={<ShiftClose/>}/>
        <Route path="car-history" element={<CarHistory/>}/>
      </Route>
      <Route path="*" element={<Navigate to="/dashboard" replace/>}/>
    </Routes>
  );
};

export default function App() {
  return <AuthProvider><BrowserRouter><AppRoutes/></BrowserRouter></AuthProvider>;
}
